export const ERROR = {
  EMAIL_ALREADY_VERIFIED: 'user already verified',
}